import { useState } from "react";
import Header from "../../../../customs/Header";
import ScoreSetupContent from "./scoreSetUp";
import { ReactComponent as World } from "../../../../svg/world.svg";
import CreateScoreContent from "./createScoreSetUpContent";
import SettingsModal from "../SettingsModal/settingsModal";

export const Main = () => {
  const [openCreateModal, setOpenCreateModal] = useState(false);
  const [openRoleModal, setOpenRoleModal] = useState(false);

  const handleOpenCreateModal = () => setOpenCreateModal(true);
  const handleCloseCreateModal = () => setOpenCreateModal(false);

  const handleOpenRoleModal = () => setOpenRoleModal(true);

  return (
    <section>
      <Header
        props={{
          firstName: "All",
          secondName: "CoreHr Score Setup",
          buttonText: "Create Score",
        }}
        handleOpen={handleOpenCreateModal}
      />

      <ScoreSetupContent handleClick={handleOpenRoleModal} />

      <SettingsModal
        header="Create Score"
        open={openCreateModal}
        maxWidth={"712px"}
        content={<CreateScoreContent handleClose={handleCloseCreateModal}  />}
        cancel={setOpenCreateModal}
        showrightIcon={false}
        worldIcon={<World/>}
      />

      
    </section>
  );
};

export default Main;

